// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".currency-result{background-color:#f2f2f4}.currency-calculator .arrow-down:after{border-left-color:#6f7486}", ""]);
// Exports
module.exports = exports;
